export default __webpack_public_path__ + "static/media/chrome-logo.d5ba6a07.svg";